import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor{
    constructor(
        private activatedRoute:ActivatedRoute
    ){

    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//        console.log("In auth header interceptor");
//        console.log("Calling the server ",req.url);
        const accessToken = localStorage.getItem('cdeAccessToken'); 
//        if(req.url.indexOf("jasper") == -1){
            const updatedRequest = req.clone({
                headers : req.headers.set('Authorization',`Bearer ${accessToken}`)
            })
            return next.handle(updatedRequest);
/*        }else{
            console.log("Request body contains")
            return next.handle(req);
        }*/


    }

}